// PrevButton.js
import React from "react";

function PrevButton({ onClick, text }) {
  return (
    <button type="button" className="wdc-btn-secondary" onClick={onClick}>
      {text || "Previous"}
    </button>
  );
}

export default PrevButton;
